// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-off-white[data-v-3ebf4cb2]{color:#c9d6df}.item-name[data-v-3ebf4cb2]{line-height:1.2}@media (min-width:600px){.item-name[data-v-3ebf4cb2]{line-height:1.5;font-size:26px!important}}.dashed-box[data-v-3ebf4cb2]{border:1px dashed grey;font-size:.8rem}", ""]);
// Exports
module.exports = exports;
